var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('f7-chip',{class:{'tag-chip': true, 'tag-chip-compact': _vm.compact, 'active': !_vm.noClick},attrs:{"text":_vm.tag.name || _vm.tag.body,"deleteable":_vm.added,"color":"gray","outline":_vm.tag.pseudo},on:{"click":_vm.onClick}})}
var staticRenderFns = []

export { render, staticRenderFns }